export default "__VITE_ASSET__jZdJNN9e__"